(function(){
"use strict";
/* Prezzo di riferimento barrato sotto il prezzo attuale, con la (i)
   che apre la spiegazione: si tratta del listino Apple al lancio del
   modello, non di un prezzo praticato da noi. */
function agisci(){
 var box=document.getElementById("wasBox");
 var val=document.getElementById("wasN");
 var save=document.getElementById("save");
 if(!box||!val)return;

 var testo=(val.textContent||"").trim();
 if(!testo)return;

 box.hidden=true;
 if(save)save.hidden=true;

 var riga=document.getElementById("demaLancio");
 if(!riga){
  riga=document.createElement("div");
  riga.id="demaLancio";
  var hr=document.querySelector(".dema-buy .hr");
  if(hr)hr.appendChild(riga); else return;
 }
 var importo=testo.replace(/^\u20ac?\s*/,"");
 var nuovo='<s>\u20ac'+importo+'</s>'+
  '<button type="button" class="info" id="demaLancioInfo" aria-label="Cosa significa questo prezzo">i</button>';
 if(riga.innerHTML!==nuovo){
  riga.innerHTML=nuovo;
  var b=document.getElementById("demaLancioInfo");
  if(b)b.addEventListener("click",function(){
   var m=document.getElementById("mLancio");
   if(m){m.classList.add("on");document.body.style.overflow="hidden"}
  });
 }
}
addEventListener("load",agisci);
setInterval(agisci,700);
})();
